import { render, staticRenderFns } from "./user_name.vue?vue&type=template&id=732b8c82&scoped=true&"
import script from "./user_name.vue?vue&type=script&lang=js&"
export * from "./user_name.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "732b8c82",
  null
  
)

export default component.exports